import $ from 'jquery' /*引入jquery*/
import drawLinkModel from './drawLinkModel.js' /*引入 绘制 文字链 模块*/
import util from './util.js' /*引入 公共工具 模块*/
	

export default function(){
	/*1级文字链点击事件*/
    $('.link-model').on('click', '.link-3txt-list>a', linkByType)
    $('.link-survery__wrap').on('click', '.link-survery__guide', function() {
        $(this).toggleClass('fold')
    })
}

/*一级文字链对象*/
var oneLevelLink = {
    _this: null, /*点击事件的指针对象*/
    type: '', /*文字链是否展开,1为展开、0为不展开(直接跳转)*/
    url: '', /*跳转 || 请求连接 */
    countNum: 0,/*2级文字链每页总个数*/
    link2LevelList: null, /*2级文字链列表对象*/
    link2LevelModel: '', /*2级文字链dom*/
    link2LevelSwiper: {}, /*2级文字链轮播图对象*/
    link2LevelSwiperKey: '', /*2级文字链轮播对象index*/
    clickLog:''
}

/*1级文字链点击方法, 通过被点击的1级文字链data-show属性判断直接跳转还是展开2级文字链列表*/
function linkByType(event) {
    oneLevelLink._this = $(this) /*被点击的1级文字链 指针*/
    oneLevelLink.type = $(this).data('show') /*被点击的1级文字链 是否展开*/
    oneLevelLink.url = $(this).data('url') /*被点击的1级文字链 链接*/
    oneLevelLink.clickLog = $(this).data('clicklog') /*被点击的1级文字链 埋点信息*/
    oneLevelLink.countNum = ($(this).parent().hasClass('link-4txt-list') || $(this).parent().hasClass('link-13pic-list')) ? 12 : 9/*被点击的文字链类别 总数: 4列12个, 3列9个*/
    if($(this).parent().hasClass('link-13pic-list')){
        oneLevelLink.link2LevelList = $(this).parent().nextAll('.link-2level-list').first()/*需要添加的目标 2级文字链列表对象*/
    }else{
        oneLevelLink.link2LevelList = $(this).nextAll('.link-2level-list').first()/*需要添加的目标 2级文字链列表对象*/
    }

    oneLevelLink.link2LevelSwiperKey = $(this).parents('.link-model').index() + '_' + $(this).data('line')
    if(oneLevelLink.type === 0 && oneLevelLink.url.trim() !== '&tag=') { /*type  0:当前的文字链不可以展开,直接访问链接*/
		/*在当前页面跳转到url地址*/
        location.assign(oneLevelLink.url + '&PGTID=' + getGTID())
    }else if(oneLevelLink.type === 1) { /*type  1:当前的文字链可以展开*/
        if(oneLevelLink._this.hasClass('link-txt-show')){/*判断当前文字链是否已经为展开状态*/
			/*移除当前文字链展开状态*/
            oneLevelLink._this.removeClass('link-txt-show')
			/*当前文字链下面的2级文字链列表隐藏*/
            oneLevelLink.link2LevelList.hide()
			/*直接返回,不进行下面的操作*/
            return
        }

        if(oneLevelLink._this.hasClass('link-txt-active')) {/*判断是否当前文字链是否已经是选中状态*/
			/*点击的1级文字链 添加link-txt-show类名*/
            oneLevelLink._this.addClass('link-txt-show')
			/*2级文字链展示*/
            oneLevelLink.link2LevelList.show()
			/*直接返回,不进行下面的操作*/
            return
        }
		
		/*当前文字链添加选中状态 && 移除同一行内的其他文字链选中状态*/
        oneLevelLink._this.addClass('link-txt-show link-txt-active').siblings('[data-line="'+ oneLevelLink._this.data('line') +'"]').removeClass('link-txt-show link-txt-active')
		
		/*请求 2级文字链列表数据接口*/
        $.ajax({
            type: 'get',
            url: oneLevelLink.url,
            dataType: 'json',
            success: function(data){
            	/*如果请求没有返回数据, 或者数据为空则请求落地页地址*/

            	// var data = {
            	// 	"state":0,"data":[{"cateid":"13810","cate":"yingyeyuan","catename":"店员/营业员"},{"cateid":"13804","cate":"shouying","catename":"收银员"},{"cateid":"13805","cate":"cuxiao","catename":"促销/导购员"},{"cateid":"13821","cate":"lihuoyuan","catename":"理货员/陈列员"},{"cateid":"23108","cate":"fangsunyuan","catename":"防损员/内保"},{"cateid":"13814","cate":"dianzhang","catename":"店长/卖场经理"},{"cateid":"23109","cate":"zhaoshangjingli","catename":"招商经理/主管"},{"cateid":"24556","cate":"shechipinyewu","catename":"奢侈品业务"},{"cateid":"24560","cate":"pinleiguanli","catename":"品类管理"},{"cateid":"24563","cate":"shipinjiagong","catename":"食品加工/处理"},{"cateid":"38738","cate":"zpdudao","catename":"督导"},{"cateid":"394375","cate":"chaoshiqita","catename":"超市/零售其他"},{"cateid":"397374","cate":"loumianguanli","catename":"楼面管理"},{"cateid":"397375","cate":"liansuozhaoshang","catename":"品牌/连锁招商管理"},{"cateid":"397376","cate":"shouyinzhuguan","catename":"收银主管"}]}

            	if(data.data.length === 0 || !data) {
            		location.assign(oneLevelLink._this.data('linkurl') + '&PGTID=' + getGTID())
            		return
            	}
            	/**
            	 * 通过 文字链模块中 2级文字链列表方法 拼接dom, 
            	 * 参数1: 接口返回数据; 
            	 * 参数2: 2级文字链每页总个数;
            	 * 参数3: 被点击的1级文字链tag, 用于拼接2级文字链的tag
            	 * @type {String}
            	 */
                 const [pos1 = '',pos2 = ''] = oneLevelLink.clickLog.split('_')
                 const modulePos = `${pos1}/${pos2}`
            	oneLevelLink.link2LevelModel = drawLinkModel.link_2Level(data, oneLevelLink,modulePos)
            	/*替换dom*/
                oneLevelLink.link2LevelList.children('ul').html(oneLevelLink.link2LevelModel)
				/*当前文字链下面的2级文字链列表显示*/
                oneLevelLink.link2LevelList.show()
				/*banner图模块轮播图初始化, 判断该2级文字链列表是否已经被初始化  
				 *如果被初始化 则更新该轮播对象, 并且翻回到第一页
				 *如果没有初始化 则初始化
				 */
                if(!oneLevelLink.link2LevelList.data('swiper')){
					/*初始化轮播对象*/
                    oneLevelLink.link2LevelSwiper[oneLevelLink.link2LevelSwiperKey] = util.initSwiper(
						oneLevelLink.link2LevelList, 
                        {
                            pagination: '.swiper-pagination',
                            paginationClickable: true
                        }
					)
					/*标记该2级文字链列表已经被初始化*/
                    if(oneLevelLink.link2LevelSwiper[oneLevelLink.link2LevelSwiperKey]){
                        oneLevelLink.link2LevelList.attr('data-swiper', 1)
                    }
                }else{
					/*翻回第一页*/
                    oneLevelLink.link2LevelSwiper[oneLevelLink.link2LevelSwiperKey].slideTo(0, 0, false)
					/*更新该轮播对象*/
                    oneLevelLink.link2LevelSwiper[oneLevelLink.link2LevelSwiperKey].update()

					/*判断是否隐藏轮播分页器*/
                    if(oneLevelLink.link2LevelList.find('.swiper-slide').length > 1) {
                        oneLevelLink.link2LevelList.find('.swiper-pagination').show()
                    }else {
                        oneLevelLink.link2LevelList.find('.swiper-pagination').hide()
                    }
                }
		    }
        })
    }
}